export const CATEGORY_COLORS: Record<string, string> = {
  servicios: '#2196F3',
  suscripciones: '#9C27B0',
  alimentacion: '#FF9800',
  transporte: '#607D8B',
  salud: '#E91E63',
  entretenimiento: '#00BCD4',
  compras: '#795548',
  educacion: '#3F51B5',
  mascotas: '#8BC34A',
  seguros: '#FF5722',
};

export const DEFAULT_CHART_COLOR = '#94a3b8';

export const CHART_COLOR_PALETTE = [
  '#2196F3',
  '#FF9800',
  '#E91E63',
  '#00BCD4',
  '#9C27B0',
  '#8BC34A',
  '#FF5722',
  '#3F51B5',
  '#607D8B',
  '#795548',
  '#4CAF50',
  '#FFC107',
  '#673AB7',
  '#03A9F4',
  '#CDDC39',
];

export const formatMXN = (value: number): string =>
  new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'MXN',
  }).format(value);

export const getCategoryColor = (category: string): string =>
  CATEGORY_COLORS[category.toLowerCase()] ?? DEFAULT_CHART_COLOR;
